import { memo } from 'react';
import { Text, Markdown, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import SyncPicError from './SyncPicError';

const SyncError = () => {
    const theme = useTheme();
    return (
        <div className="fm-ee__contentWrapper">
            <SyncPicError />
            <Text type="subtitle1" color={theme.colors.utility.textPrimary}>
                {getLiteral('text_title_sync_integration_error')}
            </Text>
            <Markdown
                content={getLiteral('label_sync_error_desc')}
                overrides={{ p: { type: 'caption', color: theme.colors.utility.textSecondary } }}
            />
        </div>
    );
};

export default memo(SyncError);
